import React, { memo } from "react";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { QuestionnaireTableQuestion } from "../QuestionnaireTableField";
import { setAnswer } from "../../../../../appRedux/actions/FormsV2";
import { createAnswer } from "../questionnarieTableScripts";
import { createOptions } from "../questionnarieTableScripts";
import { Checkbox } from "../../../../BP2Components";
import IntlMessages from "../../../../../util/IntlMessages";

interface MultiChooseFromFieldProps {
   question: QuestionnaireTableQuestion;
   formUuid: number;
}

const MultiChooseFromField: React.FC<MultiChooseFromFieldProps> = ({ question, formUuid }) => {
   const selectedItems = useSelector((state: RootStateOrAny) =>
      state.formsv2.formInfo[formUuid]?.questionnaireTableAnswers?.[question.questionId]
         ? createOptions(
              state.formsv2.formInfo[formUuid].questionnaireTableAnswers[question.questionId]
                 ?.answer,
           )
         : [],
   );

   const dispatch = useDispatch();

   const handleChange = (value: boolean, option: string) => {
      if (value !== selectedItems.includes(option)) {
         const newItems = value
            ? [...selectedItems, option]
            : selectedItems.filter((item: string) => item !== option);
         dispatch(
            setAnswer(
               createAnswer(question, {
                  answer: newItems.map((item: string) => `"${item}"`).toString(),
               }),
               formUuid,
            ),
         );
      }
   };

   return (
      <div className="questionnaire-field__container">
         <p className="p1 questionnaire-field__title">{question.content}</p>

         {typeof question?.requiredAnswers === "number" ? (
            <h3 className="h3 multi-choose-from-field__counter">
               <IntlMessages id="questionnaire.selectedAnswers" />: {selectedItems.length}/
               {question.requiredAnswers}
            </h3>
         ) : null}
         <div className="multi-choose-from-field__container">
            {question.options?.map((option, index) => (
               <Checkbox
                  checked={selectedItems.includes(option)}
                  onChange={(e) => handleChange(e.target.checked, option)}
                  name={option}
                  key={index}
                  className="multi-choose-from-field__checkbox"
                  disabled={
                     typeof question?.requiredAnswers === "number" &&
                     !selectedItems.includes(option) &&
                     selectedItems.length >= question?.requiredAnswers
                  }
               >
                  {option}
               </Checkbox>
            ))}
         </div>
      </div>
   );
};

export default memo(MultiChooseFromField);
